'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactChildrenUtilities = require('react-children-utilities');

var _reactChildrenUtilities2 = _interopRequireDefault(_reactChildrenUtilities);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioGroup = function (_Component) {
    _inherits(RadioGroup, _Component);

    function RadioGroup() {
        _classCallCheck(this, RadioGroup);

        var _this = _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).apply(this, arguments));

        _this.state = {
            value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
        };
        _this.reset = function () {
            return setTimeout(function () {
                return _this.onRadioChange(_this.props.defaultValue);
            });
        };
        _this.onRadioChange = function (newValue) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                value = _this$props.value;

            var newGroupValue = newValue;
            _this.setState({ value: value || newGroupValue });
            if (onChange) {
                onChange(newGroupValue);
            }
        };
        _this.renderChildren = function () {
            var _this$props2 = _this.props,
                inline = _this$props2.inline,
                children = _this$props2.children,
                name = _this$props2.name;

            var newProps = {
                name: name,
                onChange: _this.onRadioChange,
                radioGroupValue: _this.state.value
            };
            return _react2.default.createElement(_.Group, { selection: true, inline: inline }, _reactChildrenUtilities2.default.deepMap(children, function (child) {
                return child.type === _.Radio ? _react2.default.cloneElement(child, newProps) : child;
            }));
        };
        _this.render = function () {
            var label = _this.props.label;

            return _react2.default.createElement("div", { ref: function ref(node) {
                    return _this.groupNode = node;
                }, className: 'luna-form__field' }, label && _react2.default.createElement("label", { className: 'luna-label' }, _react2.default.createElement("strong", null, label)), _this.renderChildren());
        };
        return _this;
    }

    _createClass(RadioGroup, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.groupNode) {
                return;
            }
            var firstGroupInput = this.groupNode.querySelector('input');
            this.formNode = firstGroupInput ? firstGroupInput.form : null;
            if (this.formNode) {
                this.formNode.addEventListener('reset', this.reset, false);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.formNode) {
                this.formNode.removeEventListener('reset', this.reset);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var value = _ref.value;

            if (value !== undefined) {
                this.setState({ value: value });
            }
        }
    }]);

    return RadioGroup;
}(_react.Component);

RadioGroup.propTypes = {
    name: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    id: _propTypes2.default.string,
    inline: _propTypes2.default.bool,
    value: _propTypes2.default.node,
    defaultValue: _propTypes2.default.node
};
exports.default = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/RadioGroup/RadioGroup.js